import { Injectable } from '@angular/core';

@Injectable()
export class FormValidationMessageService {

  constructor() { }

  static getValidatorErrorMessage(validatorName: string, validatorValue?: any) {
    let config = {
        'required': 'Required',
        'email': 'Invalid email address',
        'minlength': `Minimum length ${validatorValue.requiredLength}`,
        'maxlength': `Maximum length ${validatorValue.requiredLength}`,
        'pattern': "Space not allowed in Username"

    };
    return config[validatorName];
}

}
